module.exports = __webpack_public_path__ + "img/award-coins.7d535042.svg";